import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-988f9eea")

_pushScopeId("data-v-988f9eea")
const _hoisted_1 = {
  id: "pickup-manifest",
  class: "relative bg-white flex flex-col text-12px xxl:text-14px overflow-hidden h-screen w-full"
}
const _hoisted_2 = { class: "flex flex-row py-6 align-middle items-center justify-between w-full" }
const _hoisted_3 = { class: "text-20px text-black-lp-200 flex flex-row items-center flex-no-wrap relative" }
const _hoisted_4 = {
  class: "mr-8 font-semibold",
  style: {"align-self":"center"}
}
const _hoisted_5 = {
  key: 1,
  class: "overflow-auto pb-16"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_top_up_verification_list_filter = _resolveComponent("top-up-verification-list-filter")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_top_up_verification_detail_page = _resolveComponent("top-up-verification-detail-page")!
  const _component_top_up_verification_detail_footer = _resolveComponent("top-up-verification-detail-footer")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_top_up_verification_verify = _resolveComponent("top-up-verification-verify")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", {
        class: ["flex flex-col justify-between items-start border-b border-gray-lp-400 z-20 relative", _ctx.isSidebarAndBreadcrumbV2 ? 'pt-4' : 'pt-8']
      }, [
        _withDirectives(_createVNode("div", {
          class: "fixed right-0 h-full z-20",
          style: 
          `background-color:rgba(0,0,0,0.3); top: 8.5rem; width: calc(100% - ${
            _ctx.isAdvancedFilterOpened && _ctx.isCollapseSidebar ? `69px` : `264px`
          });`
        
        }, null, 4), [
          [_vShow, _ctx.isAdvancedFilterOpened]
        ]),
        _createVNode(_component_Breadcrumb),
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("span", _hoisted_4, _toDisplayString(_ctx.getTitle), 1),
            _createVNode(_component_top_up_verification_list_filter, {
              onOpened: _ctx.onOpenedAdvancedFilter,
              modelValue: _ctx.advancedFilterData,
              "onUpdate:modelValue": _ctx.onChangeAdvancedFilter
            }, null, 8, ["onOpened", "modelValue", "onUpdate:modelValue"])
          ])
        ])
      ], 2),
      (
        _ctx.topUpVerificationList.length === 0 &&
          !_ctx.isError &&
          !_ctx.isLoading &&
          _ctx.isFirstRequest
      )
        ? (_openBlock(), _createBlock(_component_EmptyState, {
            key: 0,
            customMessage: "Oops.. Belum ada data yang dapat ditampilkan"
          }))
        : (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode(_component_TableV2, {
              columns: _ctx.columns,
              data: _ctx.topUpVerificationList,
              loading: _ctx.isLoading,
              pagination: _ctx.pagination,
              "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pagination = $event)),
              totalColumnFreeze: 0,
              isRightFreeze: "",
              onRequest: _ctx.fetchTopUpVerificationList,
              "is-detail-able": _ctx.ableToViewDetail,
              onClick: _ctx.onClickRow,
              errorCause: _ctx.errorCause,
              shadowYStart: "370",
              showRightShadow: "",
              autoHeight: ""
            }, null, 8, ["columns", "data", "loading", "pagination", "onRequest", "is-detail-able", "onClick", "errorCause"])
          ]))
    ]),
    _createVNode(_component_Dialog, {
      "show-overflow": true,
      modelValue: _ctx.dialogTopUpVerificationDetail,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.dialogTopUpVerificationDetail = $event)),
      title: "Detail Top Up",
      footer: _ctx.isAbleToRejectOrVerify
    }, {
      footer: _withId(() => [
        _createVNode(_component_top_up_verification_detail_footer, { onOpenVerify: _ctx.onOpenTopUpVerify }, null, 8, ["onOpenVerify"])
      ]),
      default: _withId(() => [
        _createVNode(_component_top_up_verification_detail_page, { id: _ctx.idDetailSelected }, null, 8, ["id"])
      ]),
      _: 1
    }, 8, ["modelValue", "footer"]),
    _createVNode(_component_top_up_verification_verify, {
      onRefresh: _ctx.fetchTopUpVerificationList,
      id: _ctx.idDetailSelected,
      modelValue: _ctx.dialogTopUpVerify,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialogTopUpVerify = $event)),
      "form-type": _ctx.topUpVerifyType,
      onCancel: _ctx.handleCancelTopUpVerify
    }, null, 8, ["onRefresh", "id", "modelValue", "form-type", "onCancel"])
  ], 64))
})